<div [class.is-mobile]="(isDesktop$ | async) === false" class="h-full">
  <main class="content">
    <router-outlet></router-outlet>
  </main>
</div>
